import { useLocation } from 'react-router-dom';
import RolesPage from './RolesPage';
import RoleBuilderPage from './RoleBuilderPage';
import { AccessCentreRouteAccessMode, AccessCentreRouteGuard } from 'domains/core/components/AccessCentreRouteGuards';
import { AccessCentrePermissionKey } from 'models/enums';

/**
 * Renders Roles list when there is no `id` in the URL query;
 * otherwise renders RoleBuilderPage (create / view / edit).
 */
const SettingsRolesRoute = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const hasId = params.has('id');

    if (hasId) {
        return (
            <AccessCentreRouteGuard
                accessMode={AccessCentreRouteAccessMode.RequireFeatureAndPermission}
                permission={AccessCentrePermissionKey.AccessManagementManage}
            >
                <RoleBuilderPage />
            </AccessCentreRouteGuard>
        );
    }
    return <RolesPage />;
};

export default SettingsRolesRoute;
